module.exports = __webpack_public_path__ + "images/959a8e732266683b799128acf46e03fd.svg";